import { ReactNode } from 'react';
import StatCard from '../ui/StatCard';

interface UptimeMetricCardProps {
  title: ReactNode;
  value: string | number;
  subtitle?: string;
  color?: 'green' | 'red' | 'yellow' | 'blue' | 'gray';
}

const colorTokens: Record<string, string | undefined> = {
  green: 'var(--status-up)',
  red: 'var(--status-down)',
  yellow: 'var(--status-warn)',
  blue: 'var(--status-info)',
  gray: undefined,
};

export default function UptimeMetricCard({
  title,
  value,
  subtitle,
  color = 'gray',
}: UptimeMetricCardProps) {
  const tint = colorTokens[color];
  return (
    <StatCard
      label={title}
      value={tint ? <span style={{ color: tint }}>{value}</span> : value}
      hint={subtitle}
    />
  );
}
